import { observable, action, computed, configure, runInAction } from "mobx";
import { createContext } from "react";
import { IProjectTime } from "../models/projecttime";
import { toast } from "react-toastify";
import agent from "../api/agent";

configure({ enforceActions: "always" });

class ProjectTimeStore {
  @observable projecttimeRegistry = new Map();
  @observable projecttime: IProjectTime | null = null;
  @observable employeeRegistry = new Map();
  @observable loadingInitial = false;
  @observable submitting = false;
  @observable target = "";

  @computed get projecttimesByName() {
    return Array.from(this.projecttimeRegistry.values()).sort((a, b) =>
      a.code.localeCompare(b.code)
    );
  }

  @computed get employeeByName() {
    return Array.from(this.employeeRegistry.values()).sort(
      (a, b) => a.name.localeCompare(b.name)
    );
  }

  @action loadProjectTimes = async () => {
    try {
      const projecttimes = await agent.ProjectTimes.list();
      runInAction('loading projecttimes', () => {
        projecttimes.forEach(projecttime => {
          this.projecttimeRegistry.set(projecttime.id, projecttime);
        });
        this.loadingInitial = false;
      })

    } catch (error) {
      runInAction('load Project Time List error' ,() => {
        this.loadingInitial = false;
      })
      toast.error('load Project Time List error');
    }
  };

  @action loadProjectTime = async (id: string) => {
    let projecttime = this.getProjectTime(id);
    if (projecttime) {
      this.projecttime = projecttime;
      return projecttime;
    } else {
      this.loadingInitial = true;
      try {
        projecttime = await agent.ProjectTimes.details(id);
        runInAction("getting Project Time", () => {
          this.loadingInitial = false;
        });
        return projecttime;
      } catch (error) {
        runInAction("get Project Time error", () => {
          this.loadingInitial = false;
        });
        toast.error("get Project Time error");
        console.log(error);
      }
    }
  };

  getProjectTime = (id: string) => {
    return this.projecttimeRegistry.get(Number(id));
  };

  @action clearProjectTime = () => {
    this.projecttime = null;
  };

  @action createProjectTime = async (projecttime: IProjectTime) => {
    this.submitting = true;
    try {
      await agent.ProjectTimes.create(projecttime);
      runInAction("create Project Time", () => {
        this.submitting = false;
      });
    } catch (error) {
      runInAction("create Project Time Error", () => {
        this.submitting = false;
      });
      toast.error("create ProjectTime Error");
      console.log(error);
    }
  };

  @action editProjectTime = async (projecttime: IProjectTime) => {
    this.submitting = true;
    try {
      await agent.ProjectTimes.update(projecttime);
      runInAction("editing projecttime", () => {
        this.projecttimeRegistry.set(projecttime.id, projecttime);
        this.projecttime = projecttime;
        this.submitting = false;
      });
    } catch (error) {
      runInAction("edit project time error", () => {
        this.submitting = false;
      });
      toast.error("edit project time error");
      console.log(error);
    }
  };

  @action deleteProjectTime = async (id: string) => {
    this.submitting = true;
    this.target = id;
    try {
      await agent.ProjectTimes.delete(id);
      runInAction("deleting Project Time", () => {
        this.projecttimeRegistry.delete(id);
        this.submitting = false;
        this.target = "";
      });
    } catch (error) {
      runInAction("edit project time error", () => {
        this.submitting = false;
        this.target = "";
      });
      toast.error("edit project time error");
      console.log(error);
    }
  };

  @action loadEmployees = async () => {
    this.loadingInitial = true;
    try {
      const employees = await agent.Employees.list();
      runInAction("loading empolyees", () => {
        this.employeeRegistry.clear();
        employees.forEach((employee) => {
          employee.dob = employee.dob.substr(0, 10);
          employee.startDate = employee.startDate.substr(0, 10);
          if (employee.status !== "Resigned" && employee.status !== "Inactive" && employee.status !== "Blacklist") 
          this.employeeRegistry.set(employee.email, employee);
        });
      });
    } catch (error) {
      runInAction("load Employee List Error", () => {
        this.loadingInitial = false;
      });
      toast.error("load Employee List Error");
    }
  };

}

export default createContext(new ProjectTimeStore());
